import { render, staticRenderFns } from "./MedicalCaseForm.vue?vue&type=template&id=66acef24"
import script from "./MedicalCaseForm.vue?vue&type=script&lang=js"
export * from "./MedicalCaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports